<template>
  <div id='bd-main'>
    <h1 style="text-align:center;">{{ userCurrentNotice.title }}
      <!-- <span style="color: red;">{{ urgent }}</span> -->
    </h1>
    <p style="text-align:center; font-size: 10px; color: gray;">{{ userCurrentNotice.user.realName }} {{ userCurrentNotice.createdAt }} {{ type }}</p>
    <p style="width: 80%; margin-left: 10%;">{{ userCurrentNotice.content }}</p>
    <p style="width: 80%; margin-left: 10%;" v-for="(attach, index) in userCurrentNotice.attachments" :key="attach">
      <a v-if="attach.length > 0" :href="attach" target="_blank">附件 {{ index + 1}}</a>
    </p>
    <div style="text-align:center; margin-top: 20px;">
      <el-button type="primary" size="mini" @click="handleCreateNotice">{{ $t('createNotice') }}</el-button>
    </div>
    <el-empty v-if="userCurrentNotice.nid === ''" description="空"></el-empty>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import bus from '@/util/eventbus'
const constants = require('@/util/constants')

export default {
  name: 'bd-main',
  computed: {
    ...mapGetters([ 'userCurrentNotice' ]),
    urgent () {
      return this.userCurrentNotice.urgent ? '[重要]' : ''
    },
    type () {
      return this.userCurrentNotice.type === '' ? '' : this.userCurrentNotice.type === 'workgroup' ? '[技能组]' : '[指定客服]'
    }
  },
  methods: {
    ...mapActions('mqtt', [ 'sendNoticeProtobuf' ]),
    handleCreateNotice () {
      bus.$emit(constants.EVENT_BUS_CREATE_NOTICE)
    }
  }

}
</script>

<style scoped>
#bd-main {
  padding-left: 10px;
  padding-top: 50px;
  text-align: left;
  height: 100%;
  width: 100%;
}
</style>
